import React from 'react';
import {Responsive, WithPermission} from 'admin-on-rest';
import {hasSystemAccess, resolveAccess} from './shared/authFunctions';
import AuthenticatedContainer from './components/AuthenticatedContainer';
import RecentTransactionsReports from './Report/RecentTransactionsReports';
import VIPUsageReports from './Report/VIPUsageReports';

import {fuseCombinedSalesReportsIcon as CombinedSalesReportsIcon} from './Report/CombinedSalesReports';
import {
    fuseCreditCardTransactionReportsIcon as CreditCardTransactionsIcon
} from './Report/CreditCardTransactionReports';
import {fuseDailySalesReportsIcon as DailySalesIcon} from './Report/DailySalesReports';
import {fuseDetailedSalesReportsIcon as DetailedSalesIcon} from './Report/DetailedSalesReports';
import {fuseDiscountsReportsIcon as DiscountsReportsIcon} from './Report/DiscountsReports';
import {fuseInventoryLogReportsIcon as InventoryLogReportsIcon} from './Report/InventoryLogReports';
import {
    fuseInventoryTransferLookupReportsIcon as InventoryTransferLookupReportsIcon
} from './Report/InventoryTransferLookupReports';
import {fuseItemSalesReportsIcon as ItemSalesIcon} from './Report/ItemSalesReports';
import {
    fuseLocationRegisterLogReportsIcon as LocationRegisterLogReportsIcon
} from './Report/LocationRegisterLogReports';
import {fusePreSettlementReportsIcon as PreSettlementReportsIcon} from './Report/PreSettlementReports';
import {fuseSalesComparisonReportsIcon as SalesComparisonReportsIcon} from './Report/SalesComparisonReports';
import {fuseSalesLogReportsIcon as SalesLogReportsIcon} from './Report/SalesLogReports';
import {fuseSalesSummaryReportsIcon as SalesSummaryReportsIcon} from './Report/SalesSummaryReports';
import {fuseSalesTaxAuditReportsIcon as SalesTaxAuditReportsIcon} from './Report/SalesTaxAuditReports';
import {fuseSettlementReportsIcon as SettlementReportsIcon} from './Report/SettlementReports';
import {fuseTransactionLogReportsIcon as TransactionLogReportsIcon} from './Report/TransactionLogReports';
import {fuseVIPSignUpsReportsIcon as VIPSignupsReportsIcon} from './Report/VIPSignupsReports';
import {fuseVIPTrendsReportsIcon as VIPTrendsReportsIcon} from './Report/VIPTrendsReports';
import {fuseInventoryOrdersIcon as InventoryOrdersIcon} from './views/InventoryOrders';
import {fuseReportJobsIcon as ReportJobsIcon} from './views/ReportJobs';
import {fuseScheduledReportsIcon as ScheduledReportsIcon} from './views/ScheduledReports';

import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import {commonStyles} from './shared/styles';

export default () => (
    <div>
        <Responsive
            small={
                <Card style={{...commonStyles.dash, ...commonStyles.marginBottom}}>
                    <ViewTitle title="Dashboard" style={commonStyles.dashTitle}/>
                    <CardText style={commonStyles.dashTitle}>
                        Welcome to CloudSent POS Reports.
                    </CardText>
                </Card>
            }
            medium={
                <Card style={{...commonStyles.dash, ...commonStyles.dashContainer, ...commonStyles.marginBottom}}>
                    <div className="dash-logo">
                        <img src="CloudSent-POS-logo-admin.png" alt="CloudSent POS"/>
                    </div>
                    <ViewTitle title="Dashboard" style={commonStyles.dashTitle}/>
                    <CardText style={commonStyles.dashTitle}>
                        Welcome to CloudSent POS Reports.
                    </CardText>
                </Card>
            }
        />

        {/* Dashboard Reports */}
        <WithPermission
            resolve={(props) => resolveAccess(props.permissions)}>
            <AuthenticatedContainer>
                <div className="margin-bottom margin-right">
                    <RecentTransactionsReports/>
                </div>
                <div className="margin-bottom margin-right">
                    <VIPUsageReports/>
                </div>
            </AuthenticatedContainer>
        </WithPermission>

        <WithPermission resolve={(props) => resolveAccess(props.permissions)}>
            {/* Sales Summary Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Sales Summary Reports"
                    subtitle="Review Totals and Averages, Top Products and Categories purchased and returned, and bihourly averages via specified filters."
                    avatar={<Avatar icon={<SalesSummaryReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Sales Summary Reports" href="#/SalesSummaryReports"/>
                </CardActions>
            </Card>

            {/* Combined Sales Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Combined Sales Reports"
                    subtitle="Review sales totals for specific organizations."
                    avatar={<Avatar icon={<CombinedSalesReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Combined Sales Reports" href="#/CombinedSalesReports"/>
                </CardActions>
            </Card>

            {/* Daily Sales Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Daily Sales Reports"
                    subtitle="Review Daily Totals of Transactions Location, to monitor payments and returns."
                    avatar={<Avatar icon={<DailySalesIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Daily Sales Reports" href="#/DailySalesReports"/>
                </CardActions>
            </Card>

            {/* Detailed Sales Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Detailed Sales Reports"
                    subtitle="Review Sales Totals and Products sold in a specified Date Range."
                    avatar={<Avatar icon={<DetailedSalesIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Detailed Sales Reports" href="#/DetailedSalesReports"/>
                </CardActions>
            </Card>

            {/* Discounts Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Discounts Reports"
                    subtitle="Review Discounts used in a specified Date Range."
                    avatar={<Avatar icon={<DiscountsReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Discounts Reports" href="#/DiscountsReports"/>
                </CardActions>
            </Card>

            {/* Item Sales Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Item Sales Reports"
                    subtitle="Review Products sold and Category percentages for Locations in a specified date range."
                    avatar={<Avatar icon={<ItemSalesIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Item Sales Reports" href="#/ItemSalesReports"/>
                </CardActions>
            </Card>

            {/* Sales Tax Audit Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Sales Tax Audit Reports"
                    subtitle="Review gross transactions and sales tax collected for Locations for multiple U.S.
                    states for a specified date range."
                    avatar={<Avatar icon={<SalesTaxAuditReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Sales Tax Audit Reports" href="#/SalesTaxAuditReports"/>
                </CardActions>
            </Card>

            {/* Pre-Settlement Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Pre-Settlement Reports"
                    subtitle="Review Sales and Inventory status for a Location with an open Final Audit, to monitor
                    gains, losses and discrepancies."
                    avatar={<Avatar icon={<PreSettlementReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Pre-Settlement Reports" href="#/PreSettlementReports"/>
                </CardActions>
            </Card>

            {/* Settlement Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Settlement Reports"
                    subtitle="Review Sales and Inventory status for a Location, to monitor gains, losses and
                        discrepancies."
                    avatar={<Avatar icon={<SettlementReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Settlement Reports" href="#/SettlementReports"/>
                </CardActions>
            </Card>

            {/* Sales Comparison Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Sales Comparison Reports"
                    subtitle="Review gross and net totals and average orders for Locations in a specified date range.
                    View additional totals and averages by individual Location."
                    avatar={<Avatar icon={<SalesComparisonReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Sales Comparison Reports" href="#/SalesComparisonReports"/>
                </CardActions>
            </Card>

            {/* Inventory Transfer Lookup Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Inventory Transfer Lookup Reports"
                    subtitle="Review all Products from a specified Inventory Transfer ID, with Product Category and
                    Quantity."
                    avatar={<Avatar icon={<InventoryTransferLookupReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Inventory Transfer Lookup Reports"
                                href="#/InventoryTransferLookupReports"/>
                </CardActions>
            </Card>

            {/* Inventory Log Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Inventory Log Reports"
                    subtitle="Review current Inventory for a specified Location."
                    avatar={<Avatar icon={<InventoryLogReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Inventory Log Reports" href="#/InventoryLogReports"/>
                </CardActions>
            </Card>

            {/* Transaction Log Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Transaction Log Reports"
                    subtitle="Review Transactions for a specified Location in a selected date/time range."
                    avatar={<Avatar icon={<TransactionLogReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Transaction Log Reports" href="#/TransactionLogReports"/>
                </CardActions>
            </Card>

            {/* Sales Log Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Sales Log Reports"
                    subtitle="Review Sales for a specified Location in a selected date/time range."
                    avatar={<Avatar icon={<SalesLogReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Sales Log Reports" href="#/SalesLogReports"/>
                </CardActions>
            </Card>

            {/* Location Register Log Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Location Register/Log Reports"
                    subtitle="Review open/close operations for a specified Location and its registers in a selected
                    date/time range."
                    avatar={<Avatar icon={<LocationRegisterLogReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Location Register/Log Reports" href="#/LocationRegisterLogReports"/>
                </CardActions>
            </Card>

            {/* Credit Card Transaction Search Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Credit Card Transaction Reports"
                    subtitle="Search credit card sales transactions to identify transactions for possible
                    chargeback."
                    avatar={<Avatar icon={<CreditCardTransactionsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Credit Card Transaction Reports" href="#/CreditCardTransactionReports"/>
                </CardActions>
            </Card>

            {/* VIP Trends Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="VIP Trends Reports"
                    subtitle="Review Product quantities purchased by VIP customers, points spent and points earned,
                    and top VIP points earners and spenders by Location."
                    avatar={<Avatar icon={<VIPTrendsReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to VIP Trends Reports" href="#/VIPTrendsReports"/>
                </CardActions>
            </Card>

        </WithPermission>

        <WithPermission
            resolve={(props) => resolveAccess(props.permissions, [], [], ['vip_signups'])}>
            {/* VIP Signups Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="VIP Signups Reports"
                    subtitle="Review total numbers of Loyalty Signups by Location."
                    avatar={<Avatar icon={<VIPSignupsReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to VIP Signups Reports" href="#/VIPSignupsReports"/>
                </CardActions>
            </Card>
        </WithPermission>

        <WithPermission
            resolve={(props) => resolveAccess(props.permissions, [], [], ['schedule_reports'])}>
            {/* Scheduled Reports */}
            <Card className="dash-card half">
                <CardHeader
                    title="Scheduled Reports"
                    subtitle="View and manage scheduled Reports, or schedule a Report."
                    avatar={<Avatar icon={<ScheduledReportsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Scheduled Reports" href="#/ScheduledReports"/>
                </CardActions>
            </Card>
        </WithPermission>

        <WithPermission
            resolve={(props) => resolveAccess(props.permissions, [], [], ['jobs'])}>
            {/* Report Jobs */}
            <Card className="dash-card half">
                <CardHeader
                    title="Report Jobs"
                    subtitle="View and download Report Jobs, or assemble a Report Job."
                    avatar={<Avatar icon={<ReportJobsIcon/>} className="avatar-title-card"/>}
                />
                <CardActions>
                    <FlatButton label="Go to Report Jobs" href="#/ReportJobs"/>
                </CardActions>
            </Card>
        </WithPermission>

        {hasSystemAccess('jakes') &&
            <WithPermission resolve={(props) => resolveAccess(props.permissions, [], [], ['inventory_orders'])}>
                {/* Inventory Orders */}
                <Card className="dash-card half">
                    <CardHeader
                        title="Inventory Orders"
                        subtitle="View and manage Inventory Orders and their individual Locations."
                        avatar={<Avatar icon={<InventoryOrdersIcon/>} className="avatar-title-card"/>}
                    />
                    <CardActions>
                        <FlatButton label="Go to Inventory Orders" href="#/InventoryOrders"/>
                    </CardActions>
                </Card>
            </WithPermission>
        }
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/dashboard.js